import { render } from "./modalText.vue?vue&type=template&id=946ed064&scoped=true"
import script from "./modalText.vue?vue&type=script&lang=js"
export * from "./modalText.vue?vue&type=script&lang=js"

import "./modalText.vue?vue&type=style&index=0&id=946ed064&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946ed064"]])

export default __exports__